<template>

    <div class="d-flex">

        <div class="graph-single">
            <div class="graph-single-progress-wrapper">
                <div
                    class="graph-single-progress"
                    :style="{height: `${animateProgressBar}%`, 'background-color': color}">
                </div>
            </div>
            <div class="graph-single-anchor" :style="{top: `${animateOverAchieved}%`}"></div>
        </div>

        <div class="graph-single-meta pl-3 d-flex flex-wrap">
            <div class="w-100 mb-2 align-self-start">
                <div class="mb-2 sm-mb-1 fw-light fs-20 sm-fs-14">Target</div>
                <div class="graph-value">{{ currencyFormat(target) }}</div>
            </div>

            <div class="w-100 align-self-end">
                <div class="mb-2 sm-mb-1 fw-light fs-20 sm-fs-14">Raised so far</div>
                <div class="graph-value">
                    <animated-number
                        :value="animateProgressValue"
                        :formatValue="currencyFormat"
                        :duration="animateDuration"
                        :update="animatedNumberUpdate"
                    />
                </div>
            </div>
        </div>

    </div>

</template>

<script>

    import AnimatedNumber from "animated-number-vue";

    import Formatter from '@/mixins/formatters';

    export default {
        name: 'SingleBlock',
        mixins: [Formatter],
        components: {AnimatedNumber},

        props: {
            color: {
                type: String,
                required: true
            },
            target: {
                type: String,
                required: true,
            },
            progress: {
                type: Number,
                required: true,
            },
        },

        data() {
            return {
                animateProgressBar: 0,
                animateProgressValue: 0,
                animateOverAchieved: 0,
                animateDuration: 1000
            }
        },

        computed: {
            /**
             * Total raised/target percentage
             * @returns {number}
             */
            achieved() {
                if (!this.target) return 100;
                return (this.progress / this.target) * 100;
            },
            /**
             * Achieved percentage,
             * For visuals always shows the percentage red line above 2%
             * @returns {number}
             */
            achievedVisual() {
                return this.achieved;
            },
            /**
             * Percentage of raised value against a target
             * @returns {number}
             */
            overAchieved() {
                if (this.achieved <= 100) return 0;
                let over = this.achieved - 100;
                return over > 99
                    ? 99 : over;
            },
            /**
             * Percentage of target against raised value
             * e.g. Target - 100, raised 80 => Target 100% of total value
             * e.g. Target - 100, raised 120 => Target 80% of total value
             * @returns {number}
             */
            targetPercentage() {
                return 100 - this.overAchieved;
            }
        },

        watch: {
            progress(val) {
                this.animateProgressValue = val;
            }
        },

        created() {
            setTimeout(() => {
                this.animateProgressBar = this.achievedVisual;
                this.animateProgressValue = this.progress;
            }, 300);
        },

        methods: {
            animatedNumberUpdate(object) {
                if (object.progress >= this.targetPercentage) {
                    this.animateOverAchieved = this.overAchieved;
                }
            }
        }
    }

</script>
